import {
  Card,
  Grid,
  TextField,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import AppService from "../../../../Configurations/Appservice";
import { useState, useEffect } from "react";
import { CUSTOMER_ORG_TYPE, CUSTOMER_USER_TYPE } from "../../../../Configurations/AppConfig";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  showSuccessMessage,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import uuid from "react-uuid";

const initialValues = {
  name: "",
  phone: "",
  email: "",
  userName: "",
  password: "",
};

const validationSchema = object({
  name: string().required("Name is Mandatory"),
  phone: string().required("Phone Number is Mandatory"),
  email: string().email().required("Email is Mandatory"),
  userName: string().required("User Name is Mandatory"),
});

const NewAgent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("New Agent"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  const _submitHandler = (values, { resetForm }) => {
    dispatch(showLoader());
    AppService.post("v1/user/agent", values)
      .then((response) => {
        resetForm();
        dispatch(showSuccessMessage("Agent User Created Successfully"));
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  };

  return (
    <WDBox py={1}>
      <Card sx={{ padding: 3 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={_submitHandler}
          validationSchema={validationSchema}
        >
          {({ errors, isValid, touched, dirty }) => (
            <Form>
              <WDBox>
                <WDTypography fontSize={14}>Create User</WDTypography>
              </WDBox>
              <WDBox my={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="name"
                        label="Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.name) && Boolean(touched.name)}
                        helperText={Boolean(touched.name) && errors.name}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="phone"
                        label="Phone Number"
                        fullWidth
                        type="tel"
                        as={TextField}
                        error={Boolean(errors.phoneNumber) && Boolean(touched.phoneNumber)}
                        helperText={Boolean(touched.phoneNumber) && errors.phoneNumber}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="email"
                        type="email"
                        label="Email"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.email) && Boolean(touched.email)}
                        helperText={Boolean(touched.email) && errors.email}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="userName"
                        label="User Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.userName) && Boolean(touched.userName)}
                        helperText={Boolean(touched.userName) && errors.userName}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="password"
                        label="Password"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.password) && Boolean(touched.password)}
                        helperText={Boolean(touched.password) && errors.password}
                      />
                    </WDBox>
                  </Grid>
                </Grid>
              </WDBox>
              <WDBox display="flex" justifyContent="flex-end" pt={3}>
                <WDButton variant="gradient" disabled={!dirty || !isValid} type="submit">
                  Submit
                </WDButton>
              </WDBox>
            </Form>
          )}
        </Formik>
      </Card>
    </WDBox>
  );
};

export default NewAgent;
